export default __webpack_public_path__ + "static/media/rent.e6da8cac.svg";